import type { SimulationState, ThemeData } from '../types';
import type { GameEvent } from '../events/GameEvents';
import type { SeededRandom } from '../rng/SeededRandom';
import { createStaff } from '../entities/StaffFactory';

export function hiringSystemUpdate(
  state: SimulationState,
  themeData: ThemeData,
  rng: SeededRandom,
): GameEvent[] {
  const events: GameEvent[] = [];

  // Process active recruiter countdown
  if (state.activeRecruiter) {
    state.activeRecruiter.ticksRemaining--;
    if (state.activeRecruiter.ticksRemaining <= 0) {
      // Recruiter found candidates — populate hiring pool
      const recruiterDef = themeData.entities.recruiters.find((r) => r.id === state.activeRecruiter!.tier);
      if (recruiterDef) {
        state.hiringPool = [];
        for (let i = 0; i < recruiterDef.candidateCount; i++) {
          const candidate = createStaff(rng, themeData);

          // Scale candidate stats by recruiter quality range
          const qualityMult = rng.nextFloat(recruiterDef.qualityMin, recruiterDef.qualityMax);
          for (const stat of Object.keys(candidate.stats)) {
            candidate.stats[stat] = Math.round((candidate.stats[stat] ?? 0) * qualityMult);
          }

          // Reputation bonus on top
          const repBonus = state.company.reputation / 100;
          for (const stat of Object.keys(candidate.stats)) {
            const bonus = Math.round((candidate.stats[stat] ?? 0) * repBonus * 0.2);
            candidate.stats[stat] = (candidate.stats[stat] ?? 0) + bonus;
          }

          // Scale salary with quality
          candidate.salary = Math.round(candidate.salary * qualityMult);
          candidate.desiredSalary = candidate.salary;

          state.hiringPool.push(candidate);
        }

        events.push({ type: 'CANDIDATES_READY', count: recruiterDef.candidateCount, tier: recruiterDef.name });
      }
      state.activeRecruiter = null;
    }
  }

  return events;
}
